import { HOME_WRAP, SectionEyebrow } from "./HomeShared";
import { trustItems } from "./HomeData";
import { useAppointment } from "../../context/AppointmentContext";
import chooseImage from "../../assets/chooseme.png";

export default function TrustSection() {
  const { openAppointment } = useAppointment();

  return (
    <section className={`${HOME_WRAP} grid gap-10 py-20 md:grid-cols-[0.92fr_1.08fr] md:items-center xl:py-24`}>
      <div>
        <SectionEyebrow>Why Choose Us</SectionEyebrow>
        <h2 className="max-w-[520px] text-[34px] font-bold leading-[1.1] text-[#071746] md:text-[44px]">
          Trusted Care.<br />Exceptional Results.
        </h2>
        <p className="mt-5 max-w-[610px] text-[17px] leading-snug text-[#4d5b7c] md:text-[20px]">
          We combine modern dental technology, experienced doctor, and a personalized approach to give every patient the best possible treatment and a confident smile.
        </p>
        <button
          type="button"
          onClick={openAppointment}
          className="mt-5 inline-flex text-[16px] font-bold text-[#0052ff] underline decoration-[#0052ff]/25 underline-offset-4 transition hover:text-[#003ec2]"
        >
          Book a personalized consultation
        </button>
        <div className="mt-14 grid gap-y-8 sm:grid-cols-2 sm:gap-x-8 xl:max-w-[720px] xl:gap-x-12">
          {trustItems.map(([number, title, text], index) => (
            <article key={title} className={`${index % 2 ? "sm:border-l sm:border-[#06386f] sm:pl-6 xl:pl-8" : ""}`}>
              <h3 className="text-[18px] font-bold text-[#06386f] xl:whitespace-nowrap">
                {number} <span className="ml-2">{title}</span>
              </h3>
              <p className="mt-3 max-w-[320px] text-[14px] leading-relaxed text-[#4d5b7c] md:text-[15px]">{text}</p>
            </article>
          ))}
        </div>
      </div>
      <div className="aspect-[850/642] w-full max-w-[850px] justify-self-end">
        <img src={chooseImage} alt="Dentist providing patient care" className="h-full w-full object-cover object-center" />
      </div>
    </section>
  );
}
